<template>
  <div class="samples-filter-actions">
    <div class="flex align-end gap-2">
      <button
        id="btnPrintSamplesLabel"
        class="btn btn-primary btn-regular-size"
        :disabled="!hasSamples"
        @click="loadingSamplesReceipt"
      >
        <svg-loader
          class="icon-print"
          src="/static/images/icon-print-alternative-white.svg"
        />

        Imprimir recibo
      </button>

      <button
        id="btnPrintBatchLabel"
        class="btn btn-primary btn-regular-size"
        :disabled="!hasSamples"
        @click="printSamplesSelected"
      >
        <svg-loader
          class="icon-print"
          src="/static/images/icon-print-alternative-white.svg"
        />

        Imprimir etiquetas

        <span v-if="selectedSamples?.length">({{ selectedSamples.length }})</span>
      </button>
    </div>

    <sample-modal-confirmation
      ref="samplesQuestionModal"
      @printTags="print"
    />

    <modal
      ref="loadingReceiptModal"
      template="loading"
      title="Aguarde"
      ref-name="loadingReceiptModal"
    >
      <p>Gerando recibo...</p>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import label from '@/api/label'

import SvgLoader from '@/components/common/SvgLoader'

import pdfkit from '../../../libs/pdfkit'
import blobstream from '../../../libs/blob-stream'
import SampleModalConfirmation from './SampleModalConfirmation'

export default {
  name: 'SamplesPrintButtons',
  components: {
    SvgLoader,
    SampleModalConfirmation
  },
  computed: {
    ...mapGetters([
      'hasSamples',
      'samples',
      'selectedSamples',
      'toggle',
      'profile'
    ])
  },
  beforeDestroy() {
    this.clearSelectedSamples()
  },
  methods: {
    ...mapActions(['printSamples', 'printReceipt', 'clearSelectedSamples']),
    async loadingSamplesReceipt() {
      this.$refs.loadingReceiptModal.open()

      await this.printReceipt(this.selectedSamples)

      this.$refs.loadingReceiptModal.close()

      this.pushEventToAnalytics('Impressão de recibo de amostra')
    },
    printSamplesSelected() {
      const samplesToPrint = this.selectedSamples.map((elem) => ({
        sample_id: elem.sample_id,
        bar_code: elem.bar_code,
        batch: {
          label: elem.batch_label,
          id: elem.batch_id ?? elem.batch_identifier
        }
      }))

      this.$refs.samplesQuestionModal.openModalConfirmation(samplesToPrint)
    },
    print(answer, samplesToPrint) {
      if (this.toggle.webPrinting) {
        const doc = new pdfkit({ size: [165.86, 83.73] })
        const stream = doc.pipe(blobstream())
        var indice
        var ind = 0

        samplesToPrint.forEach((element, index) => {
          indice = index

          label.getLabel(element.bar_code).then(response => {
            var samples = response.data

            samples.forEach(async element => {
              this.createSampleLabel(doc, element, indice, ind, stream)

              ind++
            })
          })
        })
      } else {
        this.printSamples({
          samplesId: samplesToPrint,
          printBatch: answer === 'yes',
          source: 'AOL2'
        })
      }
    },
    createSampleLabel(doc, element, indice, ind, stream) {
      let str = element.label
      let regex, label, name, infos, barcode, exam, examDescription, mnemonic, urgent, minimumVolume
      let labelType = str.substring(1, 3)

      if (labelType === 'XA') {
        regex = /(?<=FD)(.*?)(?=FS)/g
        label = str.match(regex)
        name = label[0].replace(/['"]+/g, '').replace(/['^]+/g, '')
        infos = label[1].replace(/['"]+/g, '').replace(/['^]+/g, '')
        barcode = label[3].replace(/['"]+/g, '').replace(/['^]+/g, '')
        exam = label[4].replace(/['"]+/g, '').replace(/['^]+/g, '')
        examDescription = label[5].replace(/['"]+/g, '').replace(/['^]+/g, '')
        mnemonic = label[6].replace(/['"]+/g, '').replace(/['^]+/g, '')
      } else {
        regex = /"(?:\\"|[^"])*"/g
        label = str.match(regex)
        name = label[0].replace(/['"]+/g, '')
        infos = label[1].replace(/['"]+/g, '')
        barcode = label[3].replace(/['"]+/g, '')
        exam = label[4].replace(/['"]+/g, '')
        examDescription = label[5].replace(/['"]+/g, '')
        mnemonic = label[7].replace(/['"]+/g, '')
        urgent = label[8].replace(/['"]+/g, '').replace(/['^]+/g, '')
        minimumVolume = label[6].replace(/['"]+/g, '')
      }
      doc.fontSize(6).text(name, {
        width: 150,
        height: 10,
        align: 'left'
      })
      doc.fontSize(6).text(infos, {
        width: 150,
        height: 15,
        align: 'left'
      })
      doc.image(this.textToBase64Barcode(barcode, 'itf'), 15, 25, { width: 120, height: 30 })
      doc.fontSize(6).text(exam, 10, 55, {
        align: 'left'
      })
      doc.fontSize(6).text(examDescription, 10, 62, {
        align: 'left'
      })
      if (minimumVolume !== '') {
        doc.fontSize(6).text('VOLUME MÍNIMO:' + minimumVolume, 10, 68, {
          align: 'left'
        })
      }
      if (urgent !== '') {
        doc.save()
        doc.rotate(90, { origin: [160, 20] })
        doc.rect(160, 30, 35, 8).fillAndStroke('#black', '#000')
        doc.fillColor('white').fontSize(6).text(urgent, 160, 32).fill('black')
        doc.rotate(90 * -1, { origin: [160, 20] })
        doc.restore()
      }
      doc.rect(123, 57, 30, 10).fillAndStroke('#black', '#000')
      doc.fillColor('white').fontSize(8).text(mnemonic, 123, 59).fill('black')
      if (ind < indice) {
        doc.addPage()
      }
      if (ind === indice) {
        doc.end()
        stream.on('finish', function () {
          const url = stream.toBlobURL('application/pdf')
          window.open(url)
        })
      }
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Amostras',
        action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    }
  }
}
</script>
